import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import svgIcons from "../../../assets/svg/svgIcons";
import { REPORT_TYPES } from "../../../constants/constants";

type TSubHeaderBarProps = {
  HeaderLine1: React.ReactNode;
  HeaderLine2: React.ReactNode;
  ElementAlongsideFilterButton?: React.ReactNode;
  filterButtonCallback?: () => void;
  filterResetCallback?: () => void;
  reportType?: string;
};

const SubHeaderBar: FC<TSubHeaderBarProps> = ({
  HeaderLine1,
  HeaderLine2,
  ElementAlongsideFilterButton,
  filterButtonCallback,
  filterResetCallback,
  reportType,
}) => {
  const { t: tReports } = useTranslation("translation", {
    keyPrefix: "reports",
  });

  const [showText, setShowText] = React.useState(false);

  const roundedSize = "lg";
  const sizeShapeClasses = "w-10 p-2";

  return (
    <div className={`flex justify-between py-2`}>
      {/* ${APP_CONFIG.DES.DASH.P_HORIZ} */}
      <div className="flex flex-col">
        {HeaderLine1}
        {HeaderLine2}
      </div>
      <div className="flex row-center gap-4">
        {filterResetCallback && (
          <button
            type="button"
            className="flex items-center gap-2 bg-accent-blue-pale p-2 rounded-lg transition-opacity hover:opacity-80 px-4 text-sm font-semibold text-accent-blue-dark"
            onClick={filterResetCallback}
          >
            {tReports("reset_sorting")}
          </button>
        )}
        {ElementAlongsideFilterButton}
        {filterButtonCallback && reportType !== REPORT_TYPES.SHARED_WITH_ME && (
          <button
            type="button"
            className={`relative flex items-center justify-center hover:flex-row ${showText ? `rounded-e-${roundedSize} z-listing-table-header-icons-showtext` : `rounded-${roundedSize} z-listing-table-header-icons`} ${sizeShapeClasses} bg-accent-blue-pale`}
            onClick={filterButtonCallback}
            onMouseEnter={() => setShowText(true)}
            onMouseLeave={() => setShowText(false)}
          >
            {showText && (
              <span
                className={`absolute h-full right-full top-0 text-sm font-semibold rounded-s-${roundedSize} ps-4 flex items-center leading-6 bg-accent-blue-pale group-hover:bg-accent-blue-dark whitespace-nowrap`}
              >
                {tReports("options_filter.heading")}
              </span>
            )}
            <img src={svgIcons.FilterIcon} alt="filter-icon" />
          </button>
        )}
      </div>
    </div>
  );
};
export default SubHeaderBar;
